import E2eSimulationApi from '@/api/SimulationE2e'

export class E2eSimulationRepository {
  static async create(form) {
    try {
      return E2eSimulationApi.create(form)
    } catch (e) {
      console.error(e)
      throw e
    }
  }
}
